import { defineStore } from 'pinia'
import type { SiteConfig } from '~/stores/site'

export const useConfigStore = defineStore('config', {
  state: () => ({
    config: null as SiteConfig | null,
    loading: false,
    error: null as string | null
  }),
  
  getters: {
    hasConfig: (state) => !!state.config,
    isReady: (state) => !!state.config && !state.loading
  }
})
